/**
 * Test IDs for QA automation.
 */
export const testIds = {
  carriersListCreateCarrierOrPayTo: "carriers-list-create-carrier-or-pay-to",
  carriersListTypeNavigation: "carriers-list-type-navigation",
  carriersListCarriersView: "carriers-list-carriers-view",
  carriersListPayToProfilesView: "carriers-list-pay-to-profiles-view",
} as const;
